import { isDataValid } from "./utils";

const padding = (v) => {
  let _v = v.toString();
  return _v.padStart(2, 0);
};
export const formatDate = (d, fmt, includetime = false, includesec = false) => {
  let dtarr = d.split(" ");
  let darr = dtarr[0].split("-");
  let tarr = includetime ? dtarr[1].split(":") : [];
  let fmtd = fmt
    .replace(/yyyy/i, darr[0])
    .replace(/MM/i, padding(darr[1]))
    .replace(/dd/i, padding(darr[2]));
  let fmtt = includetime
    ? `${padding(tarr[0])}:${padding(tarr[1])}${includesec ? ":" + tarr[2] : ""}`
    : "";
  return includetime ? `${fmtd} ${fmtt}` : fmtd;
};
export const procRepeat = (objArr, objArrComp) => {
  let result = objArr.filter(function (ea) {
    return objArrComp.every(function (eb) {
      return eb.filename !== ea.filename;
    });
  });
  return result;
};
export const paramNormal = (v = 0, opt = { fixed: 2, rpText: "--" }) => {
  if (isDataValid(v)) {
    return v._toFixed(opt.fixed);
  } else {
    return opt.rpText || "--";
  }
};



// WEBPACK FOOTER //
// ./src/shared/filters.js